/**
 * GENERATED by mobile/scripts/bake_eigenfield.py — do not edit by hand.
 *
 * Recipe "15" from sweetspot_wide2/recipes.json, palette "glacier" on
 * "bone" ground. The scalars below are the generator's global reductions
 * (percentile-derived fold cap, density knee, line index range) resolved once at a
 * 1080x1920 reference raster, because a fragment shader cannot compute them.
 */

export const EIGENFIELD = {
  /** Source modes, and the room's real eigenfrequencies in Hz. */
  modes: [1, 4, 9, 22],
  eigenfrequenciesHz: [38.22, 59.69, 78.11, 112.27],

  /** Stripe periods across the screen width. */
  freq: 50.000000,
  /** Displacement amplitude, already capped at the fold margin. */
  amp: 30.000000,
  weights: [0.6, 0.3, 0.25, -0.2],
  warp: 0.08,
  rot: true,
  tilt: 0.3,
  ramp0: 0.3,
  rampPow: 1.6,

  /** Anti-aliasing and density falloff. */
  densityKnee: 0.05308035,
  densityFade: 0.6,
  densityFloor: 0.1,
  /** The knee is measured per pixel of the reference raster, so the shader has to
   *  convert its own derivatives into those units before comparing. */
  referenceWidth: 1080,
  referenceHeight: 1920,

  /** Top fade, from the recipe's fade="top". */
  fadeFrac: 0.24,
  fadePow: 1.3,

  /** Per-line LUT addressing: texel = lineIndex - lutBase. */
  lutBase: -55,
  lutCount: 165,

  /** Flat ground colour (see the note about color_src="v" in the bake script). */
  ground: [0.949000, 0.937000, 0.918000],

  /** Field texture size, for the shader's normalised sampling. */
  fieldWidth: 426,
  fieldHeight: 240,
} as const;

/**
 * Animation. Each mode's weight breathes at its own real eigenfrequency, slowed so the
 * slowest is 45s. The ratios are incommensurate, so the superposition never
 * repeats and there is no loop to hide.
 */
export const EIGENFIELD_MOTION = {
  /** Seconds per cycle, per mode. */
  periodsSeconds: [45.0, 28.8139, 22.0189, 15.3193],
  /** Fraction of each weight the modulation swings. */
  depth: 0.015,
  /** Fixed phase offsets so the modes don't all start aligned. */
  phases: [0, 1.7, 3.4, 5.1],
} as const;
